export default __webpack_public_path__ + "media/dropdown-icon-down.e38a1710.svg";